import { render, staticRenderFns } from "./simple-tooltip.vue?vue&type=template&id=1764f411&scoped=true"
import script from "./simple-tooltip.vue?vue&type=script&lang=ts"
export * from "./simple-tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764f411",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1764f411')) {
      api.createRecord('1764f411', component.options)
    } else {
      api.reload('1764f411', component.options)
    }
    module.hot.accept("./simple-tooltip.vue?vue&type=template&id=1764f411&scoped=true", function () {
      api.rerender('1764f411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/benchmarking-table/tooltip-types/simple-tooltip.vue"
export default component.exports